import React from 'react';
import { TextField, MenuItem, InputAdornment, Box } from '@mui/material';
import { Form, InputGroup } from 'react-bootstrap';


import Select, { selectClasses } from '@mui/joy/Select';
import Option from '@mui/joy/Option';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';


const CostSelectorRow = ({ values, setValues }) => {
    const handleChange = (field) => (event) => {
        setValues((prev) => ({
            ...prev,
            [field]: event.target.value,
        }));
    };

    return (
        <>
            <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ gap: '12px' }} >
                <Box>
                    <Form.Label style={{ fontSize: '12px', fontWeight: '600', color: '#1A1F36', marginBottom: '0', fontFamily: 'Manrope' }}>Type</Form.Label>
                    <Select
                        placeholder="Select"
                        indicator={<KeyboardArrowDown />}
                        sx={{
                            width: 240,
                            fontSize: '14px',
                            color: '#64748B',
                            fontWeight: '600',
                            backgroundColor: '#fff',
                            boxShadow: 'unset',
                            fontFamily: 'Manrope',
                            [`& .${selectClasses.indicator}`]: {
                                transition: '0.2s',
                                fontFamily: 'Manrope',
                                [`&.${selectClasses.expanded}`]: {
                                    transform: 'rotate(-180deg)',
                                    fontFamily: 'Manrope',
                                },
                            },
                        }}
                        slotProps={{
                            listbox: {
                                sx: {
                                    zIndex: 9999,
                                },
                            },
                        }}
                    >
                        <Option value="total-cost">Total Cost</Option>
                        <Option value="total-hours">Total Hours</Option>
                    </Select>
                </Box>
                <Box>
                    <Form.Label style={{ fontSize: '12px', fontWeight: '600', color: '#1A1F36', marginBottom: '0', fontFamily: 'Manrope' }}>Based on*</Form.Label>
                    <Select
                        placeholder="Select"
                        indicator={<KeyboardArrowDown />}
                        sx={{
                            width: 124,
                            fontSize: '14px',
                            color: '#64748B',
                            fontWeight: '600',
                            backgroundColor: '#fff',
                            boxShadow: 'unset',
                            fontFamily: 'Manrope',
                            [`& .${selectClasses.indicator}`]: {
                                transition: '0.2s',
                                fontFamily: 'Manrope',
                                [`&.${selectClasses.expanded}`]: {
                                    transform: 'rotate(-180deg)',
                                    fontFamily: 'Manrope',
                                },
                            },
                        }}
                        slotProps={{
                            listbox: {
                                sx: {
                                    zIndex: 9999,
                                },
                            },
                        }}
                    >
                        <Option value="bill">Bill Rate</Option>
                        <Option value="pay">Pay Rate</Option>
                    </Select>
                </Box>

                <Box>
                    <Form.Label style={{ fontSize: '12px', fontWeight: '600', color: '#1A1F36', marginBottom: '0', fontFamily: 'Manrope' }}>Cost*</Form.Label>
                    <TextField
                        type="number"
                        value={values.cost}
                        onChange={handleChange('cost')}
                        size="small"
                        InputProps={{
                            startAdornment: <InputAdornment position="start">$</InputAdornment>,
                            sx: {
                                height: '38px',
                                backgroundColor: '#fff',
                                borderRadius: '6px',
                                fontFamily: 'Manrope',
                                // optional spacing
                            },
                        }}
                        sx={{
                            width: '124px',
                            '& .MuiInputBase-root': {
                                fontSize: '14px',
                                fontWeight: 400,
                                color: '#64748B',
                                height: '38px',
                                fontFamily: 'Manrope',

                                borderRadius: '6px',
                                backgroundColor: '#fff',
                                paddingRight: '6px',
                            },
                        }}
                    />

                </Box>
            </Box>
        </>
    );
};

export default CostSelectorRow;
